import React from 'react';

export const VideoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M63.8547 49.875C69.3099 36.7053 63.0561 21.607 49.8865 16.1518C36.7168 10.6967 21.6185 16.9505 16.1633 30.1201C10.7082 43.2897 16.962 58.3881 30.1316 63.8432C43.3012 69.2984 58.3996 63.0446 63.8547 49.875Z"
        fill="currentColor"
      />
      <path d="M42.9269 0H37.085V7.01037H42.9269V0Z" fill="currentColor" />
      <path
        d="M32.3986 0.618715L26.9026 2.09131L28.7169 8.86262L34.2129 7.39003L32.3986 0.618715Z"
        fill="currentColor"
      />
      <path
        d="M22.4021 3.98243L17.6055 6.75098L21.11 12.8227L25.9066 10.0541L22.4021 3.98243Z"
        fill="currentColor"
      />
      <path
        d="M13.638 9.81928L9.82935 13.6279L14.7864 18.585L18.595 14.7763L13.638 9.81928Z"
        fill="currentColor"
      />
      <path
        d="M6.67238 17.739L4.05518 22.272L10.1262 25.7772L12.7434 21.2442L6.67238 17.739Z"
        fill="currentColor"
      />
      <path
        d="M2.01775 27.1875L0.702393 32.0967L7.47371 33.911L8.78906 29.0018L2.01775 27.1875Z"
        fill="currentColor"
      />
      <path d="M7.01037 37.541H0V42.4716H7.01037V37.541Z" fill="currentColor" />
      <path
        d="M7.48933 46.1579L0.718018 47.9722L1.99406 52.7347L8.76538 50.9204L7.48933 46.1579Z"
        fill="currentColor"
      />
      <path
        d="M10.2448 54.4265L4.17383 57.9316L6.5632 62.07L12.6342 58.5648L10.2448 54.4265Z"
        fill="currentColor"
      />
      <path
        d="M15.0491 61.6777L10.092 66.6348L13.3637 69.9064L18.3207 64.9494L15.0491 61.6777Z"
        fill="currentColor"
      />
      <path
        d="M21.575 67.449L18.0698 73.52L21.9451 75.7575L25.4503 69.6865L21.575 67.449Z"
        fill="currentColor"
      />
      <path
        d="M29.3772 71.3122L27.5615 78.0835L31.7372 79.2032L33.5529 72.4319L29.3772 71.3122Z"
        fill="currentColor"
      />
      <path
        d="M42.0857 72.9897H37.9146V80.0001H42.0857V72.9897Z"
        fill="currentColor"
      />
      <path
        d="M50.4662 71.3535L46.5952 72.3906L48.4095 79.1619L52.2804 78.1248L50.4662 71.3535Z"
        fill="currentColor"
      />
      <path
        d="M58.1586 67.6014L54.8196 69.5293L58.3248 75.6003L61.6638 73.6724L58.1586 67.6014Z"
        fill="currentColor"
      />
      <path
        d="M64.618 62.0051L61.999 64.624L66.9561 69.5811L69.575 66.9621L64.618 62.0051Z"
        fill="currentColor"
      />
      <path
        d="M69.4508 54.9553L67.6748 58.0312L73.7458 61.5364L75.5217 58.4605L69.4508 54.9553Z"
        fill="currentColor"
      />
      <path
        d="M72.3081 46.9063L71.4282 50.1904L78.1995 52.0047L79.0795 48.7206L72.3081 46.9063Z"
        fill="currentColor"
      />
      <path
        d="M79.9999 38.3701H72.9895V41.6182H79.9999V38.3701Z"
        fill="currentColor"
      />
      <path
        d="M78.2371 28.1467L71.4658 29.9609L72.2671 32.9516L79.0385 31.1373L78.2371 28.1467Z"
        fill="currentColor"
      />
      <path
        d="M73.8962 18.7277L67.8252 22.2329L69.2974 24.7827L75.3683 21.2775L73.8962 18.7277Z"
        fill="currentColor"
      />
      <path
        d="M67.2804 10.7397L62.322 15.6953L64.296 17.6704L69.2544 12.7148L67.2804 10.7397Z"
        fill="currentColor"
      />
      <path
        d="M58.8509 4.70804L55.345 10.7783L57.6314 12.0989L61.1373 6.02859L58.8509 4.70804Z"
        fill="currentColor"
      />
      <path
        d="M49.157 1.03777L47.3413 7.80908L49.7451 8.45365L51.5608 1.68234L49.157 1.03777Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="100%" height="100%" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ScreenshotSvg = () => (
  <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-7.3e-7 39.2L0 56h56V-.00000626l-16.8 7.3e-7V39.2H-7.3e-7z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-8e-7 16.8L0 35h16.8V16.8H35V-.00000153l-18.2 8e-7L-.00000153 0-8e-7 16.8z"
      fill="currentColor"
    />
  </svg>
);

export const SharedSvg = () => (
  <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56 0H0v56h56V0zM5.6 9.5598V50.4h40.8402L36.1726 40.1324v4.7107h-5.6V30.5726h14.2429v5.6h-4.6831L50.4 46.4402V5.6H9.55979L19.8811 15.9213l.0383-4.7864 5.5998.0448-.1141 14.248H11.1846v-5.6h4.6833L5.6 9.5598zm11.0574 21.1127h-5.6v14.2704h14.2429v-5.6h-4.6846l18.727-18.7334v4.718h5.6V11.0571H30.6998v5.6h4.6757L16.6574 35.3816v-4.7091z"
      fill="currentColor"
    />
  </svg>
);

export const TeamSvg = () => (
  <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.4553 13.7276c0-2.715-.8052-5.36914-2.3136-7.62664-1.5084-2.25749-3.6523-4.017-6.1607-5.05601C16.4726.00594178 13.7124-.265911 11.0495.263772 8.3866.793456 5.94057 2.10089 4.02073 4.02073 2.10089 5.94057.793456 8.3866.263772 11.0495c-.529683 2.6629-.25783019 5.4231.781178 7.9315 1.03902 2.5084 2.79852 4.6523 5.05602 6.1607 2.25749 1.5084 4.91163 2.3135 7.62663 2.3135V13.7276h13.7277zM42.2724 27.4552c2.715 0 5.3691-.8051 7.6266-2.3135 2.2575-1.5084 4.017-3.6523 5.056-6.1607 1.0391-2.5084 1.3109-5.2686.7812-7.9315-.5297-2.6629-1.8371-5.10893-3.7569-7.02877C50.0594 2.10089 47.6134.793456 44.9505.263772c-2.6629-.529683-5.4231-.25783046-7.9315.781178-2.5084 1.03901-4.6523 2.79852-6.1607 5.05601-1.5084 2.2575-2.3136 4.91164-2.3136 7.62664h13.7277v13.7276zM28.5447 42.2724c0 2.715.8052 5.3691 2.3136 7.6266 1.5084 2.2575 3.6523 4.017 6.1607 5.056 2.5084 1.0391 5.2686 1.3109 7.9315.7812 2.6629-.5297 5.1089-1.8371 7.0288-3.7569 1.9198-1.9199 3.2272-4.3659 3.7569-7.0288.5297-2.6629.2579-5.4231-.7812-7.9315-1.039-2.5084-2.7985-4.6523-5.056-6.1607s-4.9116-2.3135-7.6266-2.3135v13.7276H28.5447zM13.7276 28.5448c-2.715 0-5.36914.8051-7.62663 2.3135-2.2575 1.5084-4.017 3.6523-5.05602 6.1607-1.03900742 2.5084-1.31086 5.2686-.781177 7.9315.529683 2.6629 1.837117 5.1089 3.756957 7.0288 1.91984 1.9198 4.36587 3.2272 7.02877 3.7569 2.6629.5297 5.4231.2579 7.9315-.7811 2.5084-1.0391 4.6523-2.7986 6.1607-5.0561s2.3136-4.9115 2.3136-7.6266H13.7276V28.5448z"
      fill="currentColor"
    />
  </svg>
);

export const GenericSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 102 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H102V102H0V0Z" fill="#DDDDE1" />
    <path
      d="M21.2635 21.2635H30.855L30.8634 21.2255L31.1631 21.2635H89.9995V12.8203H12.8203V89.9995H21.2635V21.2635Z"
      fill="#F7F7F8"
    />
    <path
      d="M38.1628 30.6736L48.2819 31.9696L48.3241 31.8303L49.1938 32.0836L89.9997 37.3099V28.7992L31.1634 21.2637H30.8552L22.0574 89.9997H30.5681L38.1628 30.6736Z"
      fill="#F7F7F8"
    />
    <path
      d="M62.9516 44.8878L62.9812 44.8245L63.3569 45.006L89.9994 52.7695V43.9759L49.1934 32.0837L48.2816 31.9697L31.3699 89.9998H40.1635L54.0652 42.3L62.9516 44.8878Z"
      fill="#F7F7F8"
    />
    <path
      d="M62.9519 44.8872L41.0376 89.9992H50.4264L66.8864 56.1082L75.203 60.1483L75.2114 60.1356L75.2494 60.1694L89.9996 67.3334V57.9446L63.3572 45.0054L62.9519 44.8872Z"
      fill="#F7F7F8"
    />
    <path
      d="M75.2022 60.1489L51.2573 89.9998H62.0815L76.5151 72.0074L89.9989 82.8231V71.9989L75.2486 60.17L75.2022 60.1489Z"
      fill="#F7F7F8"
    />
  </svg>
);
export const ShareVideoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8485 27.5V36.1515H27.5C22.7205 36.1515 18.8485 32.2795 18.8485 27.5Z"
      fill="currentColor"
    />
    <path
      d="M36.1515 27.5001V18.8486H27.5C32.2795 18.8486 36.1515 22.7206 36.1515 27.5001Z"
      fill="currentColor"
    />
    <path
      d="M27.5 18.8486H18.8485V27.5001C18.8485 22.7206 22.7205 18.8486 27.5 18.8486Z"
      fill="currentColor"
    />
    <path
      d="M27.5 36.1515H36.1515V27.5C36.1515 32.2795 32.2795 36.1515 27.5 36.1515Z"
      fill="currentColor"
    />
    <path
      d="M0 0V55H55V0H0ZM44.803 5.5C46.717 6.4845 48.213 8.162 48.9665 10.197H44.803V5.5ZM36.1515 5.5C39.5065 5.5 42.4105 7.4085 43.846 10.197H36.1515C36.1515 7.4085 36.1515 5.5 36.1515 5.5ZM27.5 5.5C30.855 5.5 33.759 7.4085 35.1945 10.197H19.8055C21.241 7.4085 24.145 5.5 27.5 5.5ZM18.8485 5.5C18.8485 5.5 18.8485 7.4085 18.8485 10.197H11.154C12.5895 7.4085 15.4935 5.5 18.8485 5.5ZM10.197 49.5C8.283 48.5155 6.787 46.838 6.0335 44.803H10.197V49.5ZM10.197 43.846C7.4085 42.4105 5.5 39.5065 5.5 36.1515H10.197V43.846ZM10.197 35.1945C7.4085 33.759 5.5 30.855 5.5 27.5C5.5 24.145 7.4085 21.241 10.197 19.8055V35.1945ZM10.197 18.8485H5.5C5.5 15.4935 7.4085 12.5895 10.197 11.154V18.8485ZM10.197 10.197H6.0335C6.787 8.162 8.283 6.4845 10.197 5.5V10.197ZM44.803 49.5V44.803H48.9665C48.213 46.838 46.717 48.5155 44.803 49.5ZM44.803 43.846V36.1515H49.5C49.5 39.5065 47.5915 42.4105 44.803 43.846ZM44.803 27.5V19.8055C47.5915 21.241 49.5 24.145 49.5 27.5C49.5 30.855 47.5915 33.759 44.803 35.1945V27.5C44.803 32.2795 40.931 36.1515 36.1515 36.1515H44.803C44.803 40.931 40.931 44.803 36.1515 44.803H43.846C42.4105 47.5915 39.5065 49.5 36.1515 49.5C36.1515 49.5 36.1515 47.5915 36.1515 44.803C36.1515 44.803 36.1515 40.931 36.1515 36.1515C36.1515 40.931 32.2795 44.803 27.5 44.803H35.1945C33.759 47.5915 30.855 49.5 27.5 49.5C24.145 49.5 21.241 47.5915 19.8055 44.803H27.5C22.7205 44.803 18.8485 40.931 18.8485 36.1515C18.8485 40.931 18.8485 44.803 18.8485 44.803C18.8485 47.5915 18.8485 49.5 18.8485 49.5C15.4935 49.5 12.5895 47.5915 11.154 44.803H18.8485C14.069 44.803 10.197 40.931 10.197 36.1515H18.8485C14.069 36.1515 10.197 32.2795 10.197 27.5C10.197 22.7205 14.069 18.8485 18.8485 18.8485H10.197C10.197 14.069 14.069 10.197 18.8485 10.197C18.8485 10.197 18.8485 14.069 18.8485 18.8485C18.8485 14.069 22.7205 10.197 27.5 10.197C32.2795 10.197 36.1515 14.069 36.1515 18.8485C36.1515 14.069 36.1515 10.197 36.1515 10.197C40.931 10.197 44.803 14.069 44.803 18.8485V11.154C47.5915 12.5895 49.5 15.4935 49.5 18.8485H44.803H36.1515C40.931 18.8485 44.803 22.7205 44.803 27.5Z"
      fill="currentColor"
    />
  </svg>
);

export const CustomBrandingSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.7419 0V55H27.2581V0H27.7419Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6167 0.87207L34.8507 54.0021L34.3834 54.1273L20.1494 0.997278L20.6167 0.87207Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9595 3.56348L41.4595 51.1935L41.0405 51.4354L13.5405 3.8054L13.9595 3.56348Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.22304 7.88086L47.119 46.7769L46.7769 47.119L7.88092 8.22298L8.22304 7.88086Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.80595 13.54L51.436 41.04L51.194 41.459L3.56403 13.959L3.80595 13.54Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.997583 20.1494L54.1276 34.3834L54.0024 34.8508L0.872375 20.6168L0.997583 20.1494Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 27.293H55V27.7065H0V27.293Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.872375 34.3834L54.0024 20.1494L54.1276 20.6168L0.997583 34.8508L0.872375 34.3834Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.56403 41.04L51.194 13.54L51.436 13.959L3.80595 41.459L3.56403 41.04Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.88092 46.7769L46.7769 7.88086L47.119 8.22298L8.22304 47.119L7.88092 46.7769Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5405 51.1935L41.0405 3.56348L41.4595 3.8054L13.9595 51.4354L13.5405 51.1935Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1494 54.0021L34.3834 0.87207L34.8507 0.997278L20.6167 54.1273L20.1494 54.0021Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.1203 27.5V55H26.8797V27.5H28.1203Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.0992 27.3398L35.2162 53.9048L34.0178 54.2259L26.9008 27.6609L28.0992 27.3398Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.0372 27.1895L41.7872 51.0045L40.7128 51.6248L26.9628 27.8098L28.0372 27.1895Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.9386 27.0615L47.3866 46.5095L46.5094 47.3868L27.0614 27.9388L27.9386 27.0615Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.8101 26.9629L51.6251 40.7129L51.0048 41.7873L27.1898 28.0373L27.8101 26.9629Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.6605 26.9004L54.2255 34.0174L53.9045 35.2157L27.3395 28.0987L27.6605 26.9004Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 26.8799H55V28.1205H0V26.8799Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.774475 34.0174L27.3395 26.9004L27.6605 28.0987L1.09552 35.2157L0.774475 34.0174Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.37482 40.7129L27.1898 26.9629L27.8101 28.0373L3.99513 41.7873L3.37482 40.7129Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.6134 46.5095L27.0614 27.0615L27.9386 27.9388L8.49064 47.3868L7.6134 46.5095Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2128 51.0045L26.9628 27.1895L28.0372 27.8098L14.2872 51.6248L13.2128 51.0045Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7838 53.9048L26.9008 27.3398L28.0992 27.6609L20.9822 54.2259L19.7838 53.9048Z"
      fill="currentColor"
    />
  </svg>
);

export const ArchivedSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0V80H80V0H0ZM72 72H8V8H72V72Z" fill="currentColor" />
    <path
      d="M69.6 10.4004H42.944C49.672 11.6244 54.944 16.9604 56.112 23.7044H69.6V10.4004Z"
      fill="currentColor"
    />
    <path
      d="M37.056 10.4004H10.4V23.7044H23.888C25.048 16.9604 30.328 11.6244 37.056 10.4004Z"
      fill="currentColor"
    />
    <path
      d="M10.4 26.1035V38.7995H24.952C27.448 32.9435 33.232 28.8235 40 28.8235C46.768 28.8235 52.552 32.9435 55.048 38.7995H69.6V26.1035H10.4Z"
      fill="currentColor"
    />
    <path
      d="M10.4 53.8962H26.72C29.688 49.7762 34.528 47.0802 39.992 47.0802C45.464 47.0802 50.296 49.7682 53.264 53.8962H69.6V41.2002H10.4V53.8962Z"
      fill="currentColor"
    />
    <path
      d="M10.4 69.5999H29.176C32.064 67.0559 35.848 65.5039 40 65.5039C44.152 65.5039 47.936 67.0479 50.824 69.5999H69.6V56.2959H10.4V69.5999Z"
      fill="currentColor"
    />
  </svg>
);
export const StarredSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.1697 0C13.9595 0 0 14.5082 0 32.3949V39.2H7.55517C24.7729 39.2 38.3992 24.3268 38.3992 6.44015V0.00156244L31.1697 0Z"
      fill="currentColor"
    />
    <path
      d="M80 31.1711C80 13.9612 65.4915 0.00195249 47.6045 0.00195171L40.7992 0.00195141L40.7992 7.55697C40.7992 24.7743 55.6727 38.4005 73.5597 38.4005L79.9984 38.4005L80 31.1711Z"
      fill="currentColor"
    />
    <path
      d="M48.8303 80C66.0405 80 80 65.4918 80 47.6051L80 40.8L72.4448 40.8C55.2271 40.8 41.6008 55.6732 41.6007 73.5599L41.6007 79.9984L48.8303 80Z"
      fill="currentColor"
    />
    <path
      d="M4.08742e-06 48.8289C1.83057e-06 66.0388 14.5085 79.998 32.3955 79.9981L39.2008 79.9981L39.2008 72.443C39.2008 55.2257 24.3273 41.5995 6.44028 41.5995L0.0015675 41.5995L4.08742e-06 48.8289Z"
      fill="currentColor"
    />
  </svg>
);
